import { call, getContext, put, takeEvery, all } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes, ProductAddToBasketLocations } from '../../../enums/ActionEnums';
import { getBasicBasket, getBasket } from './BasketSagas';
import { checkStockReservation } from './CheckStockReservationSaga';
import { BasketCartItemError } from '@as-react/common-types';
export function* increaseProductQuantity(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield put(basketActions.createUpdateItemsErrorStateAction(null));
        yield call(BasketAPI.addProductToBasket, action.payload.product, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createAddSuccessAction({
            product: action.payload.product,
            location: ProductAddToBasketLocations.BASKET_QUANTITY,
        }));
        yield put(basketActions.createGetBasicAction());
        yield put(basketActions.createGetAction());
    }
    catch (_a) {
        yield all([call(getBasicBasket), call(getBasket), call(checkStockReservation)]);
        yield put(basketActions.createUpdateItemsErrorStateAction(BasketCartItemError.ADD_FAILED, action.payload.product));
    }
}
export function* increaseProductQuantitySaga() {
    yield takeEvery(BasketActionTypes.INCREASE_QUANTITY, increaseProductQuantity);
}
